import useSendFile from "@hooks/useSendFile";
import { useState } from "react";
import Loading from "~/components/Loading";

const FormEsperienza = ({ attrs }) => {
  const sendForm = async () => {
    let error = false;
    if (
      nameSurname.match(
        /^\s*([a-zA-Zàèéìòù]+)??(?:\s+)?([a-zA-Zàèéìòù]+)??\s*(['-])?\s*([a-zA-Zàèéìòù]+)\s*/
      ) == null
    ) {
      setNameSurnameMessage("Il campo nome e cognome non può essere vuoto");
      error = true;
    }
    if (
      email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/) == null
    ) {
      setEmailMessage("Il campo email non può essere vuoto");
      error = true;
    }
    if (message == "" && fileEsperienza == undefined) {
      setMessageMessage("Inserisci un messaggio o invia un allegato");
      error = true;
    }
    if (
      phoneNumber != "" &&
      phoneNumber.match(
        /(^[\+]?[0-9]{0,3}\W+){0,1}[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/g
      ) == null
    ) {
      setPhoneNumberMessage("il numero di telefono non è corretto");
      error = true;
    }
    if (privacy == 0) {
      setMessagePrivacy("Devi accettare i termini per inviare l'esperienza");
      error = true;
    }
    if (error) return setError(new Error("Compila i campi obbligatori"));
    setError(null);
    setLoading(true);

    try {
      const idForm = attrs.id;
      SendFile(
        nameSurname,
        email,
        phoneNumber,
        message,
        fileEsperienza,
        idForm
      );
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
    setEmail("");
    setNameSurname("");
    setPhoneNumber("");
    setMessage("");
    setMessagePrivacy("");
    setPrivacy(0);
  };
  function handleChange(event) {
    if (event.target.name.includes("email")) {
      setEmail(event.target.value);
      setEmailMessage("");
    }
    if (event.target.name.includes("nameSurname")) {
      setNameSurname(event.target.value);
      setNameSurnameMessage("");
    }
    if (event.target.name.includes("phoneNumber")) {
      setPhoneNumber(event.target.value);
      setPhoneNumberMessage("");
    }
    if (event.target.name.includes("message")) {
      setMessage(event.target.value);
      setMessageMessage("");
    }
    if (event.target.name.includes("file")) {
      setSelectedFiles(event?.target?.files?.[0]);
      setMessageMessage("");
    }
  }
  const [fileEsperienza, setSelectedFiles] = useState<File | undefined>(
    undefined
  );
  const [email, setEmail] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [nameSurname, setNameSurname] = useState("");
  const [nameSurnameMessage, setNameSurnameMessage] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberMessage, setPhoneNumberMessage] = useState("");
  const [message, setMessage] = useState("");
  const [messageMessage, setMessageMessage] = useState("");
  const [messageResponce, setMessageResponce] = useState("");
  const [error, setError] = useState<Error>();
  const [loading, setLoading] = useState(false);
  const [privacy, setPrivacy] = useState(0);
  const [messagePrivacy, setMessagePrivacy] = useState("");
  const { SendFile } = useSendFile(setMessageResponce);
  return (
    <div className="mx-auto flex flex-col bg-[#e5e6e7] px-4 py-8 sm:px-10">
      <label className="pl-0 text-lg font-medium">
        <input
          type="text"
          name="nameSurname"
          id="nameSurname"
          value={nameSurname}
          onChange={handleChange}
          onClick={() => setMessageResponce("")}
          placeholder="Nome e Cognome"
          className="w-full rounded-full border-[1px] border-solid border-lightGray p-2.5 pr-3.5 text-lg"
        />
        {nameSurnameMessage && (
          <div className="mt-2 text-red-500">{nameSurnameMessage}</div>
        )}
      </label>
      <label className="pl-0 text-lg font-medium">
        <input
          type="email"
          name="email"
          id="email"
          value={email}
          onChange={handleChange}
          onClick={() => setMessageResponce("")}
          placeholder="Email"
          className="w-full rounded-full border-[1px] border-solid border-lightGray p-2.5 pr-3.5 text-lg"
        />
        {emailMessage && (
          <div className="mt-2 text-red-500">{emailMessage}</div>
        )}
      </label>
      <label className="pl-0 text-lg font-medium">
        <input
          type="tel"
          name="phoneNumber"
          id="phoneNumber"
          value={phoneNumber}
          onChange={handleChange}
          onClick={() => setMessageResponce("")}
          placeholder="Telefono"
          className="w-full rounded-full border-[1px] border-solid border-lightGray p-2.5 pr-3.5 text-lg"
        />
        {phoneNumberMessage && (
          <div className="mt-2 text-red-500">{phoneNumberMessage}</div>
        )}
      </label>
      <p className="mt-2">
        {attrs.id == 52033
          ? `Scrivi direttamente la tua esperienza o inviala come allegato (.pdf,
        .doc, .docx o .txt | massimo 2MB)`
          : `Se nessuna di queste risposte soddisfa la tua esigenza, inviaci la tua domanda. Ti risponderemo via email
Se incontri dei problemi a trovare il tuo codice abbonato, specifica per favore il tuo indirizzo di spedizione`}
      </p>
      {messageMessage && <div className="text-red-500">{messageMessage}</div>}
      <label className="pl-0 text-lg font-medium">
        <textarea
          name="message"
          rows={6}
          id="message"
          value={message}
          onChange={handleChange}
          onClick={() => setMessageResponce("")}
          placeholder="Il tuo messaggio"
          className="w-full rounded-3xl border-[1px] border-solid border-lightGray p-2.5 pr-3.5 text-lg"
        />
      </label>
      {attrs.id == 52033 && (
        <label className="pl-0 text-lg font-medium">
          <input
            name="file"
            id="file"
            type="file"
            accept="pdf,doc,docx,txt"
            onChange={handleChange}
            onClick={() => setMessageResponce("")}
            placeholder="Il tuo messaggio"
            className="mt-2 w-full p-2.5 pr-3.5 text-lg"
          />
        </label>
      )}
      <span className=" flex items-center gap-2 text-lg">
        <input
          type="checkbox"
          className="!mt-[2px] mr-4 !flex"
          value={privacy}
          onChange={() => setPrivacy(privacy == 0 ? 1 : 0)}
          onClick={() => setMessagePrivacy("")}
          checked={privacy == 1}
        />
        <label className=" !mt-0 items-center text-lg lg:flex">
          Letta
          <a
            className="pl-1 text-lg text-[#4e5460]"
            target="_blank"
            href="https://privacy.sgi-italia.org/"
          >
            l&apos;informativa privacy
          </a>
          , presto il consenso al trattamento dei dati per le finalità
          descritte.
        </label>
      </span>
      {messagePrivacy && <div className="text-red-500">{messagePrivacy}</div>}

      <button
        className="mx-auto w-full rounded-full border-[1px] border-solid border-lightGray bg-[#4e5460] p-4 uppercase text-white sm:w-1/4"
        onClick={sendForm}
      >
        <div className="flex items-center justify-center">
          {loading && <Loading />} invia
        </div>
      </button>
      {error && (
        <div className="mt-8 text-center text-red-500">
          Errore: {error.message}
        </div>
      )}
      {messageResponce != "" && <p>{messageResponce}</p>}
    </div>
  );
};

export default FormEsperienza;
